import React from 'react';

const AnchorButton = ({ value, children, className, ...props }) => {
  className += ` btn-get-started scrollto`;
  return (
    <a href={value} className={className} {...props}>{children}</a>
  );
};

export default AnchorButton;